<template>
  <div>
    <b-card>
      <div
        v-for="station in stations"
        :id="station.CODE"
        :key="station.CODE"
        class="d-block mt-2">
        <b-btn
          :class="[station.COLLAPSED ? null : 'collapsed']"
          :aria-controls="station.CODE"
          :aria-expanded="station.COLLAPSED ? 'true' : 'false'"
          size="sm"
          @click="toggleCollapse(station.CODE)">
          <i :class="[station.COLLAPSED ? 'icon-minus' : 'icon-plus']"/>
        </b-btn>
        <div class="d-inline ml-2">
          <h5 class="ml-2 d-inline"><span class="badge badge-success">{{ station.NAME }}</span></h5>
          <div class="float-right">
            <span>
              Average Rating:
              <star-rating
                :rating="getAverageRating(station.CODE)"
                :star-size="16"
                :show-rating="false"
                :read-only="true"
                class="align-top"
                inline/>
            </span>
            <span
              v-show="station.AVERAGE_RATING < 1"
              class="badge badge-danger">No rating data</span>
          </div>
        </div>

        <b-collapse
          :id="station.CODE"
          v-model="station.COLLAPSED">
          <CarsView
            :cars="cistByStation(station.CODE)"
            :car-in-stations="carInStations"
            :car-logs="carLogs"
            class="mt-2"/>
        </b-collapse>
      </div>
    </b-card>
  </div>
</template>
<script>
import CarsView from './CarsView'
import StarRating from 'vue-star-rating'

export default {
  name: 'StationView',
  components: {
    CarsView,
    StarRating
  },
  props: {
    carLogs: {
      type: Array,
      default: () => []
    },
    stations: {
      type: Array,
      default: () => []
    },
    zoneCode: {
      type: String,
      default: ''
    },
    carInStations: {
      type: Array,
      default: () => []
    }
  },
  methods: {
    cistByStation (stationCode) {
      return this.$store.getters['cleaningLogs/getCistByStation'](stationCode)
    },
    toggleCollapse(stationCode) {
      this.$store.commit('cleaningLogs/toggleStation', stationCode)
    },
    getAverageRating (stationCode) {
      return this.$store.getters['cleaningLogs/getAvgRateStation'](stationCode)
    }
  }
}
</script>
